import axios from "@/plugins/axios.js";
const API_ADMIN_URL = "/api/admin";

export default {
  async GetUsers({ page, pageSize, search }) {
    return axios.get(`${API_ADMIN_URL}/users`, {
      params: { page, pageSize, search },
    });
  },
  async GetUserBets(userId) {
    return axios.get(`${API_ADMIN_URL}/users/${userId}/bets`);
  },
  // POST zamiast PUT - hosting/IIS blokuje PUT/DELETE
  async UpdateUserBet(userId, matchId, bet) {
    return axios.post(`${API_ADMIN_URL}/users/${userId}/bets/${matchId}`, bet);
  },
  async GetMatches(competitionsId) {
    return axios.get(`${API_ADMIN_URL}/matches`, {
      params: { competitionsId },
    });
  },
  // POST zamiast PUT - hosting/IIS blokuje PUT/DELETE
  async UpdateMatch(matchId, match) {
    return axios.post(`${API_ADMIN_URL}/matches/${matchId}`, match);
  },
};
